import React from 'react';
import { Link } from 'react-router-dom';
import why_work from '../../../../assets/images/why-work.png';
import CustomModalView from '../../../../common/input/customModal/customModalView';

const CommonRegistrationView = (props) => {
  return (
    <>
      <section className="login-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 login-center">
              <div className="login-form-main">
                <div className="registration-form_wrapper">
                  <div className="content">
                    <img src={why_work} alt="" />
                    <h3>carerconnect</h3>
                    <h4>Whenever Wherever</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 login-center">
              <div className="login-form ">
                <h3>Create Your Account</h3>
                <form>
                  <div className="field-box">
                    <input
                      type="text"
                      onChange={(e) =>
                        props.handelData('first_name', e.target.value)
                      }
                      name="firstname"
                      placeholder="First name"
                    />
                    <div className="form-error-msg-register">
                      {props.setfirstname_validate}
                    </div>
                  </div>
                  <div className="field-box">
                    <input
                      type="text"
                      onChange={(e) =>
                        props.handelData('last_name', e.target.value)
                      }
                      name="lastname"
                      placeholder="Last name"
                    />
                    <div className="form-error-msg-register">
                      {props.setlastname_validate}
                    </div>
                  </div>
                  <div className="field-box">
                    <input
                      type="email"
                      onChange={(e) =>
                        props.handelData('email', e.target.value)
                      }
                      name="email"
                      placeholder="Email Address"
                    />
                    <div className="form-error-msg-register">
                      {props.email_match}
                    </div>
                  </div>
                  <div className="field-box">
                    <input
                      type="email"
                      onChange={(e) =>
                        props.handelData('confirmemail', e.target.value)
                      }
                      name="email"
                      placeholder="Confirm Email Address"
                    />
                  </div>
                  <div className="field-box">
                    <input
                      type={props.visible_password ? 'text' : 'password'}
                      onChange={(e) =>
                        props.handelData('password', e.target.value)
                      }
                      name="password"
                      placeholder="Password"
                    />
                    <div className="form-error-msg-register">
                      {props.setpassword_validate}
                    </div>
                  </div>
                  <p className="text-left form-check">
                    <input
                      type="checkbox"
                      onClick={(e) => props.show_password(e)}
                    />
                    <span> Show Password</span>
                  </p>
                  {/* <div className="field-box">
                                        <input type="password" onChange={(e) => props.handelData('confirmpassword', e.target.value)} name="password" placeholder="Confirm Password" />
                                        <div className="form-error-msg-register">{props.matchalert}</div>
                                    </div> */}
                  <div className="field-box">
                    <button type="button" onClick={props.handelSummit}>
                      Register <i className="fa fa-sign-in"></i>
                    </button>
                  </div>
                </form>
                <p>
                  Already Have an Account? {/* <Link href="/login"> */}
                  <span className="signup">Sign In</span>
                  {/* </Link> */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
        custom_model={props.custom_model}
        strong_text={props.strong_text}
        h5_text={props.h5_text}
        h1_text={props.h1_text}
      />
    </>
  );
};

export default CommonRegistrationView;
